export default __webpack_public_path__ + "static/media/079-shark.38d03163.svg";